import { EXTENDED_MENU_SECTION_CHANGED } from '@shopDetails/actionTypes';

const extendedMenuSectionChanged = sectionId => ({
  type: EXTENDED_MENU_SECTION_CHANGED,
  payload: sectionId,
});

export default extendedMenuSectionChanged;
